import React from 'react';
import { FormattedMessage } from 'react-intl';
import MainPage from '../containers/MainPage';
import Page404 from '../components/Page404';
import LoginPage from '../containers/LoginPage';
import Hotline from '../containers/Hotline';
import TicketList from '../containers/TicketList';
import Ticket from '../containers/Ticket';
import NewTicket from '../containers/NewTicket';
import SignUp from '../containers/SignUp';
import SignUpVerify from '../containers/SignUpVerify';
import PasswordRecovery from '../containers/PasswordRecovery';
import HomeIcon from '@material-ui/icons/Home';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import PasswordRecoveryVerify from '../containers/PasswordRecoveryVerify';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import License from '../containers/License';
import HashSubscriptions from '../containers/HashSubscriptions';

export const getUriMap = () =>
  ({
    '/': {
      exact: true,
      noDrawer: true,
      hideFromBreadcrumbs: true,
      addToDrawer: true,
      drawerIcon: <HomeIcon />,
      pageName: () => <FormattedMessage id="pageNames.home" defaultMessage="Home" />,
      Component: MainPage,
    },
    '/login/:login?/:password?': {
      noAuth: true,
      pageName: () => <FormattedMessage id="pageNames.login" defaultMessage="Login" />,
      Component: LoginPage,
    },
    '/sign-up': {
      exact: true,
      noAuth: true,
      pageName: () => <FormattedMessage id='pageNames.signUp' defaultMessage='Sign up' />,
      Component: SignUp,
    },
    '/sign-up/verify/:email?/:key?': {
      exact: true,
      noAuth: true,
      pageName: () => <FormattedMessage id='pageNames.signUpVerify' defaultMessage='Email verification' />,
      Component: SignUpVerify,
    },
    '/hash/subscriptions/:hash': {
      exact: true,
      noAuth: true,
      pageName: () => <FormattedMessage id='pageNames.subscriptions' defaultMessage='Subscriptions' />,
      Component: HashSubscriptions,
    },
    '/password-recovery': {
      exact: true,
      noAuth: true,
      pageName: () => <FormattedMessage id='pageNames.passwordRecovery' defaultMessage='Recover password' />,
      Component: PasswordRecovery,
    },
    '/password-recovery/verify/:email?/:key?': {
      exact: true,
      noAuth: true,
      pageName: () => <FormattedMessage id='pageNames.passwordRecoveryVerify' defaultMessage='Email verification' />,
      Component: PasswordRecoveryVerify,
    },
    '/hotline': {
      exact: true,
      addToDrawer: true,
      drawerIcon: <LiveHelpIcon />,
      pageName: () => <FormattedMessage id="pageNames.hotline" defaultMessage="Hotline" />,
      Component: Hotline,
    },
    '/license': {
      exact: true,
      addToDrawer: true,
      drawerIcon: <VpnKeyIcon />,
      pageName: () => <FormattedMessage id="pageNames.license" defaultMessage="License keys" />,
      Component: License,
    },
    '/hotline/:type': {
      exact: true,
      pageName: ({ type }) => <FormattedMessage id="pageNames.hotline.ticketList" defaultMessage="{type} tickets" values={{ type }} />,
      Component: TicketList,
    },
    '/hotline/:type/ticket/:tn': {
      exact: true,
      pageName: ({ tn }) => <FormattedMessage id="pageNames.hotline.ticket" defaultMessage="Ticket #{tn}" values={{ tn }} />,
      Component: Ticket,
    },
    '/hotline/:type/create': {
      exact: true,
      pageName: () => <FormattedMessage id="pageNames.hotline.ticketCreate" defaultMessage="Create ticket" />,
      Component: NewTicket,
    },
    '': {
      hideFromBreadcrumbs: true,
      pageName: () => <FormattedMessage id="pageNames.404" defaultMessage="404 Not Found" />,
      Component: Page404,
    },
  });
